<template>
  <v-container class="login-wrap fill-height" fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="5" class="login-col">
        <div class="text-center mb-6">
          <img :src="logo" alt="Sea Tow" class="login-logo" />
        </div>

        <v-card class="pa-8 text-center" elevation="8" rounded="lg">
          <h1 class="text-h5 font-weight-medium mb-1">Call Agent Helper</h1>
          <p class="text-body-2 text-medium-emphasis mb-6">
            Sign in with your <strong>@seatow.com</strong> Microsoft account to continue.
          </p>

          <v-btn
            :loading="loading"
            color="primary"
            size="large"
            block
            variant="flat"
            @click="login"
          >
            <img :src="msIcon" alt="" class="ms-logo" />
            Sign in with Microsoft
          </v-btn>

          <v-alert
            v-if="error"
            type="error"
            variant="tonal"
            density="compact"
            class="text-start mt-4"
          >{{ error }}</v-alert>
        </v-card>

        <p class="text-caption text-medium-emphasis text-center mt-6">
          &copy; {{ year }} Sea Tow Services International
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { signIn } from "../services/auth";
import logoOnWhite from "../assets/ST_logo_onwhite.png";
import logoOnBlack from "../assets/ST_logo_onblack.png";
import msIcon from "../assets/mssymbol.svg";

export default {
  name: "LoginView",
  data: () => ({
    loading: false,
    error: null,
    msIcon,
    year: new Date().getFullYear(),
  }),
  computed: {
    // dark theme → the white-on-dark logo, light theme → the dark-on-light logo
    logo() {
      return this.$vuetify.theme.global.current.dark ? logoOnBlack : logoOnWhite;
    },
  },
  methods: {
    async login() {
      this.loading = true;
      this.error = null;
      try {
        await signIn();
        this.$router.push("/");
      } catch (e) {
        this.error = "Sign-in failed or was cancelled. Please try again.";
        console.error(`error during authentication: ${e}`);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-wrap {
  min-height: 100vh;
}

.login-col {
  max-width: 460px;
}

.login-logo {
  height: 48px;
  width: auto;
  max-width: 80%;
}

.ms-logo {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
</style>
